<template>
  <Index v-if="!isServiceEnd" />
  <ServiceEnd v-else />
</template>

<script>
import Index from '@/index/components/2025/Index.vue'
import ServiceEnd from '@/common/components/ServiceEnd.vue'

export default {
  name: 'App',
  components: {
    Index,
    ServiceEnd
  },
  data() {
    return {
      isServiceEnd: false
    }
  },
  mounted() {
    const now = new Date()
    const endDate = new Date('2025-08-31T23:59:59')
    this.isServiceEnd = now > endDate
  }
}
</script>
